module.exports = __webpack_public_path__ + "static/type-bc589b6c7eddd1fc98bb59afa7002ef3.png";